const data = {
  head: {
    title: 'Aktuelle Stellenangebote bei audibene',
    description:
      'Unsere Vision ist es, Menschen weltweit zu besserem Hören zu verhelfen. Werde Teil unseres bunten Teams und mache die Welt ein bisschen glücklicher.',
    favicon: 'favicon-de.ico'
  },
  benefits: {
    title: 'Benefits',
    items: [
      {
        title: 'Growth',
        icon: 'de/Benefits/Benefit_Growth.png',
        text:
          'We believe people are happiest at work when they have room to grow. Regular one-on-ones and dedicated growth sessions support your continuous development, helping you reach your full potential and career goals.'
      },
      {
        title: 'Health',
        icon: 'de/Benefits/Benefit_Health.png',
        text:
          'Beyond your Urban Sports Club membership, recharge with rooftop yoga sessions and connect with colleagues over cross-functional team lunches with drinks and coffee always available. This is how we care for your well-being.'
      },
      {
        title: 'Team',
        icon: 'de/Benefits/Benefit_Team.png',
        text:
          'A strong sense of team matters to us. Regular team events, Offsites, and peer clubs strengthen cohesion and a pleasant atmosphere plus a free Deutschlandticket to encourage regular office interactions.'
      },
      {
        title: 'Impact',
        icon: 'de/Benefits/Benefit_Impact.png',
        text:
          "Your contribution matters, we foster a culture where every voice is heard and new approaches are welcome. We firmly believe innovation comes from our teams' diversity as we shape the future of hearing care together."
      }
    ]
  },
  trustwidgets: {
    items: [
      {
        url:
          'https://kununu.com/de/audibene1?rfr=affiliate_widget&utm_content=widget_icon_text_small&utm_medium=affiliate&utm_source=widget',
        imgSrc: 'de/Trust/kununu-widget-icon.svg',
        imgTitle: 'kununu'
      },
      {
        url: 'https://www.glassdoor.de/Überblick/Arbeit-bei-audibene-EI_IE1155737.11,19.htm',
        imgSrc: 'de/Awards/glassdoor_en.jpg',
        imgTitle: 'glassdoor'
      }
    ]
  },
  awards: {
    items: [
      {
        icon: 'de/Awards/kununu-open-company_de.png'
      },
      {
        icon: 'de/Awards/kununu-top-company_de.png'
      },
      {
        icon: 'de/Awards/kununu-Top-Company-Siegel 2023.png'
      }
    ]
  },
  carousel: {
    slides: [
      {
        img: {
          mobile: 'de/Carousel/miracle_m.jpg',
          desktop: 'de/Carousel/miracle.jpg'
        },
        title: 'From a Berlin start-up to one of the leading hearing care companies worldwide',
        text:
          'We are the fastest growing hearing care company ever. Shortly after starting in Berlin we expanded from there to two continents. Today, we have offices in Berlin, Mainz, Marseille, Rotkreuz, Utrecht, New Delhi, Denver, Miami, Cape Town and Seoul.'
      },
      {
        img: {
          mobile: 'de/Carousel/marco_and_paul_m.jpg',
          desktop: 'de/Carousel/marco_and_paul.jpg'
        },
        title: 'A vision is born',
        text:
          'Our founders Marco Vietor and Paul Crusius already knew each other from university. Together, they had the idea to fight prejudices about hearing aids. Ultimately, they wanted to help people, in an innovative and simple way, to better hearing - and thus, a better quality of life.'
      },
      {
        img: {
          mobile: 'de/Carousel/wohnzimmer_m.jpg',
          desktop: 'de/Carousel/wohnzimmer.jpg'
        },
        title: 'It all started in this living room',
        text:
          "In 2012 Marco, Paul and 3 other colleagues started audibene. Actually, our first phone calls were done out of Marco's living room. Without any desks, only with laptops and phones."
      },
      {
        img: {
          mobile: 'de/Carousel/koepenicker_m.jpg',
          desktop: 'de/Carousel/koepenicker.jpg'
        },
        title: 'Our first office',
        text:
          'Three months later they moved into the first real office in Berlin Kreuzberg: Desks for everyone and plenty of space. From then on, they helped more and more people every day and our team grew so quickly that it soon became quite crowded again.'
      },
      {
        img: {
          mobile: 'de/Carousel/zaudibene_m.jpg',
          desktop: 'de/Carousel/zaudibene.jpg'
        },
        title: 'Growing up',
        text:
          'Two more relocations and a number of new colleagues later, we opened up the audibene headquarters with around 220 employees in Prenzlauer Berg Berlin today and another office in Mainz. It was important to maintain a living room dynamic.'
      },
      {
        img: {
          mobile: 'de/Carousel/us-office_m.jpg',
          desktop: 'de/Carousel/us-office.jpg'
        },
        title: 'Higher, faster, further',
        text:
          "Our founders' vision resonated. And not just in Germany – people in other parts of Europe, North America, Asia, and Africa also want to improve their lives with audibene.  Today, all colleagues from over 45 nations ensure good and easy hearing in 8 countries around the world. Further markets are not excluded."
      }
    ]
  },
  development: {
    title: 'Get to know our team',
    items: [
      {
        img: 'de/Development/portrait_01.jpg',
        innerTitle: 'Christina',
        innerSubtitle: 'Senior Team Lead Customer Sales Consulting',
        innerCopy:
          "“I joined audibene Berlin in 2015 as a customer consultant. In the meantime, I've moved back to my beloved hometown, Mainz, and became the lead of one of our customer consultant teams.”"
      },
      {
        img: 'de/Development/portrait_02.jpg',
        innerTitle: 'Gui',
        innerSubtitle: 'Senior Platform Engineer',
        innerCopy:
          '"What makes me enjoy working at audibene is my colleagues and how open and friendly they are. My team is very experienced and knowledgeable, I enjoy the challenging and dynamic discussions we have."'
      },
      {
        img: 'de/Development/portrait_03.jpg',
        innerTitle: 'Sabine',
        innerSubtitle: 'Senior Business Development Manager',
        innerCopy:
          '"I started in 2020 at audibene in Talent Acquisition, where I had a fantastic time learning a lot. After three years, when I was ready for a new challenge, I was offered the opportunity to join an exciting new project – since then, I’ve been supporting the Business Development team and growing together with audibene."'
      }
    ]
  },
  footer: {
    social: [
      {
        title: 'LinkedIn',
        icon: 'linkedin.svg',
        url:
          'https://www.linkedin.com/company/audibene?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      },
      {
        title: 'Xing',
        icon: 'xing.svg',
        url:
          'https://www.xing.com/pages/audibene?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      },
      {
        title: 'Instagram',
        icon: 'instagram.svg',
        url:
          'https://www.instagram.com/weareaudibene/?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      },
      {
        title: 'youtube',
        icon: 'youtube.svg',
        url: 'https://www.youtube.com/channel/UCgxXCeJf-rlwNQK73J2nyPw'
      },
      {
        title: 'Blog',
        icon: 'blog.svg',
        url:
          'https://inside.audibene.de/?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      }
    ],
    international: {
      title: 'audibene/hear.com international:',
      links: [
        {
          title: 'Netherlands',
          icon: 'flag_netherlands@2x.png',
          url: 'https://www.audibene.nl'
        },
        {
          title: 'Switzerland',
          icon: 'flag_switzerland@2x.png',
          url: 'https://www.audibene.ch'
        },
        {
          title: 'Canada',
          icon: 'flag_canada@2x.png',
          url: 'https://www.hear.com/ca'
        },
        {
          title: 'France',
          icon: 'flag_france@2x.png',
          url: 'https://www.audibene.fr/'
        },
        {
          title: 'USA',
          icon: 'flag_usa@2x.png',
          url: 'https://www.hear.com/'
        },
        {
          title: 'India',
          icon: 'IN_flag@2x.png',
          url: 'https://www.hear.com/in'
        },
        {
          title: 'Malaysia',
          icon: 'flag_malaysia@2x.png',
          url: 'https://www.hear.com/my'
        },
        {
          title: 'Germany',
          icon: 'flag_germany@2x.png',
          url: 'https://www.audibene.de/'
        },
        {
          title: 'South Korea',
          icon: 'flag_south_korea@2x.png',
          url: 'https://www.hear.com/kr'
        }
      ]
    },
    nav: [
      {
        title: 'Imprint',
        url: 'https://www.audibene.de/impressum/'
      },
      {
        title: 'Terms & Conditions',
        url: 'https://www.audibene.de/agb-datenschutz/'
      },
      {
        title: 'Privacy Policy',
        url: 'https://www.audibene.de/datenschutz/'
      },
      {
        title: 'Press',
        url: 'https://www.audibene.de/presse/'
      }
    ]
  },
  header: {
    url: 'https://www.audibene.de/',
    logo: process.env.PUBLIC_URL + '/Assets/de/Header/audibene-logo.svg',
    items: [
      {
        text: 'This is us',
        anchor: 'who'
      },
      {
        text: 'Benefits',
        anchor: 'benefits'
      },
      {
        text: 'Jobs',
        anchor: 'jobs'
      }
    ]
  },
  hero: {
    img: {
      mobile: 'de/Hero/hero-audibene-de.jpg',
      desktop: 'de/Hero/hero-audibene-de.jpg'
    },
    title: 'Jobs at audibene',
    subtitle: "We make people's lives better.",
    cta: {
      text: 'Open positions',
      anchor: 'jobs'
    }
  },
  jobs: {
    title: 'Apply now!'
  },
  offices: {
    title: {
      mobile: 'Locations in Germany',
      desktop: 'Locations in Germany - Where do you want to work?'
    },
    items: [
      [
        {
          block: 'image',
          img: 'de/Offices/o_01.jpg'
        },
        {
          block: 'text',
          title: 'Berlin',
          text:
            'Around 220 colleagues, 7 friendly dogs and a 200m² rooftop terrace await you at our headquarters in Berlin. On 4 floors with loft character, we ensure good hearing worldwide from Prenzlauer Berg. This is the place where the marketing threads of all our offices come together.'
        },
        {
          block: 'image',
          img: 'de/Offices/o_02.jpg'
        }
      ],
      [
        {
          block: 'image',
          img: 'de/Offices/o_03.jpg'
        },
        {
          block: 'image',
          img: 'de/Offices/o_04.jpg'
        },
        {
          block: 'text',
          title: 'Mainz',
          text:
            'At the RheinCampus in Mainz, we combine our international training center for our hearing advisors and a hearing acoustics studio with state-of-the-art technology. We also offer office space for our colleagues in and around Mainz. All this with a direct view of the beautiful Rhine.'
        }
      ],
      [
        {
          block: 'text',
          title: 'Home office',
          titleMobile: 'Home office',
          text:
            "There's no place like home, is there? In sales, you can work remotely from anywhere in Germany – wherever we don't have an office close to you. And thanks to state-of-the-art video technology, you'll feel close to your colleagues even from your living room."
        },
        {
          block: 'image',
          img: 'de/Offices/o_05.jpg'
        },
        {
          block: 'image',
          img: 'de/Offices/o_06.jpg'
        }
      ]
    ]
  },
  values: {
    title: 'Our values',
    items: [
      {
        title: 'Change lives',
        icon: 'de/Values/change-lives.svg',
        text: "We change people's lives with better hearing. This is what drives us."
      },
      {
        title: 'One Team',
        icon: 'de/Values/one-team.svg',
        text: 'We truly enjoy working together and love celebrating our successes as a team.'
      },
      {
        title: 'Entrepreneurs',
        icon: 'de/Values/entrepreneurs.svg',
        text: 'We are entrepreneurs. We take risks and make things happen fast.'
      },
      {
        title: 'Growth',
        icon: 'de/Values/growth.svg',
        text: 'We focus on growth. Personal growth. Team growth. Customer growth.'
      },
      {
        title: 'Responsibility',
        icon: 'de/Values/responsibility.svg',
        text: 'You are in charge. We have no organizational chart.'
      }
    ]
  },
  who: {
    title: 'This is us',
    text:
      'Our vision is to help people around the world to hear better. Thanks to state-of-the-art technology with an almost invisible design, today, nobody has to live with bad hearing. Become part of our colourful team and make the world a better place.',
    success: {
      title: 'Our success story',
      items: [
        {
          number: '2012',
          text: 'Founded'
        },
        {
          number: '8',
          text: 'Countries'
        },
        {
          number: '1.200',
          text: 'Colleagues'
        },
        {
          number: '45',
          text: 'Nationalities'
        }
      ]
    }
  },
  work: {
    title: 'How we work',
    blocks: [
      {
        img: {
          desktop: 'de/Work/presentation.jpg',
          mobile: 'de/Work/presentation-mobile.jpg'
        },
        textBlock: {
          title: 'One team, one dream',
          text:
            "We work on projects across teams and don't think or act in departments. Hierarchies hardly play a role. Instead, we communicate on equal terms and value each other's opinions - no matter what your experience level is."
        }
      }
    ]
  },
  video: {
    videoLink:
      'https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/careers-site/video/Audibene_GmbH_-_Imagefilm.mp4',
    playImg: 'de/Video/play.svg',
    coverImg: 'de/Video/video-cover.jpg'
  },
  // sales page
  salesHero: {
    img: {
      mobile: 'de/Hero/hero-audibene-de-sales.jpg',
      desktop: 'de/Hero/hero-audibene-de-sales.jpg'
    },
    title: 'Finde deinen Traumjob',
    subtitle: 'In unserem Sales Team.',
    cta: {
      text: 'Jetzt bewerben!',
      link: 'https://boards.greenhouse.io/audibenehearcom/jobs/2205293'
    }
  },
  // sales campaign page
  salesCampaignHero: {
    img: {
      mobile: 'de/Hero/hero-audibene-de-sales.jpg',
      desktop: 'de/Hero/hero-audibene-de-sales.jpg'
    },
    title: 'Finde deinen Traumjob',
    subtitle: 'In unserem Sales Team.',
    cta: {
      text: 'Jetzt bewerben!',
      link: 'https://boards.greenhouse.io/audibenehearcom/jobs/4706391'
    }
  },
  whatAwaits: {
    title: 'Das erwartet dich bei audibene:',
    items: [
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-1.svg',
        text: 'Viele Kund:innen, die du jeden Tag mit gutem Hören glücklich machst.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-2.svg',
        text: 'Ein hochmodernes Arbeitsumfeld im Home Office oder Büro.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-3.svg',
        text: 'Tolle Kolleg:innen in einer familiären Arbeitsatmosphäre.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-4.svg',
        text: 'Ein attraktives, leistungsorientiertes Gehalts- und Provisionsmodell.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-5.svg',
        text: 'Aktive Weiterentwicklung mit Trainings und Coachings.'
      }
    ]
  },
  salesJob: {
    title: 'Der Job im Sales Team bei audibene',
    blocks: [
      {
        img: {
          desktop: 'de/SalesJob/mainz-consultant_desktop.jpg',
          mobile: 'de/SalesJob/mainz-consultant_mobile.jpg'
        },
        textBlock: {
          text:
            'Der Job als Sales Consultant bei uns ist vielfältig. Direkt beim Start erhältst du warme Kontakte von Menschen, die sich auf unserer Website angemeldet haben. Von da an begleitest du sie auf dem Weg zu besserem Hören und mehr Lebensqualität – vom ersten Kontakt bis hin zum Abschluss. Inhaltlich bist du dafür verantwortlich, Kund:innen am Telefon oder über Video zu beraten, sie zum Testen von Hörgeräten zu motivieren und den Verkauf abzuschließen. Unsere größte Zielgruppe, die Babyboomer, ist dabei anspruchsvoll und erwartet eine kompetente und einfühlsame Beratung.'
        }
      },
      {
        img: {
          desktop: 'de/SalesJob/berlin-consultant_desktop.jpg',
          mobile: 'de/SalesJob/berlin-consultant_mobile.jpg'
        },
        textBlock: {
          text:
            'Nachdem du im Erstgespräch Termine vereinbart hast, organisierst du deine eigene Pipeline und arbeitest auf dein Umsatzziel hin. Deinen Arbeitsalltag bestimmst du dabei selbständig. Während des gesamten Prozesses kommunizierst du sowohl mit deinen Kund:innen als auch mit den entsprechenden Partnerakustiker:innen. So stellst du sicher, dass du die optimale Lösung findest.'
        }
      }
    ]
  },
  audibeneModel: {
    title: 'Das weltweit einzigartige audibene Modell: Zwei Wege zum perfekten Hörgerät',
    items: [
      {
        icon: {
          color: '#A0CFEB'
        },
        text:
          'Über konsequentes Online-Marketing erreichen wir gezielt moderne, aktive Menschen mit Hörproblemen – und motivieren sie, sich zum kostenlosen Testen von Mini-Hörgeräten auf unserer Website anzumelden. Mehrere tausend neue Kund:innen registrieren sich auf diese Weise jede Woche bei uns!'
      },
      {
        icon: {
          color: '#6AADE4'
        },
        text:
          'Nach der Registrierung meldet sich ein Sales Consultant aus unserem Team telefonisch oder per Video-Call. In dieser Erstberatung werden alle Fragen rund um das Thema Hörgeräte geklärt, eine Bedarfsanalyse durchgeführt und ein Termin zur Anpassung vereinbart.'
      },
      {
        icon: {
          color: '#00549F'
        },
        text:
          'Bei der Anpassung wird ein exakter Hörtest durchgeführt und ein geeignetes Hörgeräte-Modell zum Probetragen eingestellt – entweder klassisch in einem unserer Partner-Akustikgeschäfte oder digital per Video-Call. Für den digitalen Weg schicken wir unsere HörErlebnisBox nach Hause: mit Hörgerät und der nötigen Technik für den Termin. So erreichen wir Menschen auch dort, wo kein Fachgeschäft in der Nähe ist.'
      },
      {
        icon: {
          color: '#21314D'
        },
        text:
          'Jetzt können unsere Kund:innen die Hörgeräte über 4 Wochen im Alltag testen. Dabei werden sie regelmäßig von uns kontaktiert und beraten, bei Bedarf wird das Modell gewechselt oder weiter angepasst. Diese „beidseitige“ Expert:innenberatung führt schneller und effizienter zum Hör-Erfolg als bei anderen Hörakustiker:innen.'
      },
      {
        icon: {
          color: '#FFA100'
        },
        text:
          'Sobald das perfekte Hörgerät gefunden ist, schließt der Sales Consultant den Verkauf ab.'
      }
    ]
  },
  apply: {
    title: 'Bewerben bei audibene: In nur 5 Schritten zum Traumjob',
    text:
      'Unser Ziel ist es, die besten Sales Consultants in ganz Deutschland zu finden! Deshalb nehmen wir uns viel Zeit für dich und deine Bewerbung. Du bekommst bei uns die Möglichkeit, den Job vorab hautnah zu erleben. So weißt du am Ende genau, worauf du dich einlässt. Plane für den gesamten Prozess 2 Wochen ein.',
    items: [
      {
        icon: {
          src: 'de/Apply/ico-application.svg'
        },
        text:
          '<strong>Bewerbung:</strong> Bewirb dich einfach und unkompliziert mit deinem Lebenslauf oder deinem aktuellen LinkedIn-Profil. Ein Anschreiben brauchst du nicht.'
      },
      {
        icon: {
          src: 'de/Apply/ico-phone.svg'
        },
        text:
          '<strong>Erstes Interview:</strong> Zunächst führst du ein ca. 30-minütiges Kennenlerngespräch per Telefon oder Video mit einer:einem unserer Recruiter:innen. Dabei sprechen wir über die Rolle als Sales Consultant und deine bisherige Erfahrung.'
      },
      {
        icon: {
          src: 'de/Apply/ico-laptop.svg'
        },
        text:
          '<strong>Zweites Interview:</strong> Anschließend hast du ein Gespräch mit einer:einem unserer Teamleiter:innen. Hier gehen wir besonders auf deine Vertriebserfahrung und deine Motivation ein. Im Anschluss bekommst du von uns ausführliches Feedback.'
      },
      {
        icon: {
          src: 'de/Apply/ico-convo.svg'
        },
        text:
          '<strong>Einblick in den Job und drittes Interview:</strong> Du schaust einem unserer Sales Consultants direkt bei der Arbeit über die Schulter – auch per Video-Call möglich. Danach führst du ein finales Gespräch mit unserem Senior Sales Leadership.'
      },
      {
        icon: {
          src: 'de/Apply/ico-contract.svg'
        },
        text:
          '<strong>Angebot und Vertragsabschluss:</strong> Alles hat geklappt. Eine/r unserer Recruiter:innen meldet sich bei dir, um dir die frohe Nachricht zu überbringen und mit dir alle Vertragsdetails zu besprechen.'
      }
    ],
    ctas: [
      {
        text: 'Sales Consultant in Berlin »',
        link: 'https://job-boards.greenhouse.io/audibenehearcom/jobs/7950095'
      },
      {
        text: 'Sales Consultant in Mainz »',
        link: 'https://job-boards.greenhouse.io/audibenehearcom/jobs/7950109'
      },
      {
        text: 'Sales Consultant deutschlandweit »',
        link: 'https://job-boards.greenhouse.io/audibenehearcom/jobs/7950268'
      }
    ]
  },
  applyCampaign: {
    title: 'Bewerben bei audibene: In nur 5 Schritten zum Traumjob',
    text:
      'Unser Ziel ist es, die besten Vertriebler:innen in ganz Deutschland zu finden! Deshalb nehmen wir uns gerne besonders viel Zeit für dich und deine Bewerbung. Du erhältst nach jedem Schritt ein ausführliches Feedback von uns. Insgesamt solltest du ca. 2 Wochen für den gesamten Prozess einplanen.',
    cta: {
      text: 'Hier geht es zum Bewerbungsformular »',
      link: 'https://boards.greenhouse.io/audibenehearcom/jobs/4706391'
    },
    items: [
      {
        icon: {
          src: 'de/Apply/ico-application.svg'
        },
        text:
          '<strong>Bewerbung:</strong> Bewirb dich einfach und unkompliziert mit deinem Lebenslauf oder deinem XING Profil. Ein Anschreiben ist dabei nicht notwendig.'
      },
      {
        icon: {
          src: 'de/Apply/ico-phone.svg'
        },
        text:
          '<strong>Erstes Interview:</strong> Zunächst hast du ein ca. 30-minütiges telefonisches Kennenlerngespräch mit einem unserer Recruiter bzw. mit einer unserer Recruiterinnen. Dabei besprechen wir die Rolle des Customer Sales Consultants und deine bisherige Erfahrung.'
      },
      {
        icon: {
          src: 'de/Apply/ico-laptop.svg'
        },
        text:
          '<strong>Probe-Arbeiten:</strong> Danach erhältst du die Möglichkeit, hautnah dabei zu sein und einem unserer Hörexperten oder einer unserer Hörexpertinnen über die Schulter zu schauen. Natürlich funktioniert das Ganze auch über Video-Telefonie im Home Office.'
      },
      {
        icon: {
          src: 'de/Apply/ico-convo.svg'
        },
        text:
          '<strong>Zweites Interview:</strong> Zuletzt hast du ein Gespräch mit einem/r unserer Team- oder Regionalleiter:innen. Hier gehen wir besonders auf deine Vertriebserfahrung ein.'
      },
      {
        icon: {
          src: 'de/Apply/ico-contract.svg'
        },
        text:
          '<strong>Angebot und Vertragsabschluss:</strong> Alles hat geklappt. Eine/r unserer Recruiter:innen meldet sich bei dir, um dir die frohe Nachricht zu überbringen und mit dir alle Vertragsdetails zu besprechen.'
      }
    ]
  },
  homeOffice: {
    title: 'Erfolgreich im Home Office',
    blocks: [
      {
        text:
          'Arbeiten aus dem Home Office ist bei uns im Sales von Anfang an möglich. Wer nicht in der Nähe unserer Standorte in Berlin oder Mainz lebt, arbeitet dauerhaft von zuhause – das sind rund 80 % unseres Sales Teams. Mit modernster Videokommunikation (Zoom) und cloudbasierter CRM-Software (Salesforce) bist du dabei voll angebunden.'
      },
      {
        text:
          'Team-orientiertes Arbeiten ist uns sehr wichtig. Dazu bist du täglich mit deinen Kolleg:innen über Videotelefonie in Kontakt. Zusätzlich veranstalten wir jedes Quartal ein Teamevent und zwei bis dreimal im Jahr Partys und Ausflüge, bei denen du deine Kolleg:innen auch persönlich triffst.'
      }
    ]
  },
  carouselSales: {
    title: 'Einarbeitung, Weiterentwicklung und Coaching',
    textBlocks: [
      {
        text:
          'Für uns ist Weiterentwicklung ein wichtiger Teil unserer Firmenkultur. Alle in unserem Team möchten einen guten Job machen und sich dabei konstant verbessern.'
      },
      {
        text:
          'Das fängt mit Herausforderungen im Job an: Die Vielfältigkeit unserer Kund:innen erfordert, dass man sich immer wieder neu an verschiedene Persönlichkeiten anpassen muss und seinen Vertriebsstil weiterentwickelt. Dabei unterstützen wir dich.'
      }
    ],
    slides: [
      {
        img: {
          mobile: 'de/Coaching/coaching_1_mobile.jpg',
          desktop: 'de/Coaching/coaching_1_desktop.jpg'
        },
        title: 'Einarbeitung und Coaching',
        text:
          'Unsere Sales Academy begleitet dich von Anfang an: Sie verantwortet deine strukturierte Einarbeitung in den ersten zwei Monaten und führt danach regelmäßig Vertriebstrainings durch. Erfahrene Sales Coaches stehen dir außerdem im individuellen Coaching zur Seite.'
      },
      {
        img: {
          mobile: 'de/Coaching/coaching_2_mobile.jpg',
          desktop: 'de/Coaching/coaching_2_desktop.jpg'
        },
        title: 'Entwicklungsstufen und Rollenwechsel',
        text:
          'Gute Leistung zahlt sich bei uns aus – finanziell und mit mehr Verantwortung. Unsere Entwicklungsstufen sind klar definiert: Vom Sales Consultant über Senior und Expert bis zur Stufe Diamant. Wer zusätzlich bereichsübergreifend Erfahrung sammeln möchte, kann über unser 4+1-Modell einen Tag pro Woche in einem anderen Team mitarbeiten.'
      }
    ]
  },
  audibeneKultur: {
    title: 'Lerne unser Team kennen',
    items: [
      {
        img: 'de/Kultur/portrait_03.jpg',
        innerTitle: 'Johannes',
        innerSubtitle: 'Expert Customer Sales Consultant',
        innerCopy:
          '„Ich bin seit 2015 bei audibene und mir macht es jeden Tag aufs Neue Spaß Menschen zum Thema besser Hören zu unterstützen, damit diese wieder besser am aktuellen Leben teilnehmen können. Ich stehe als Kundenberater für alle Fragen zum Thema Hörgeräte immer gerne zur Verfügung.“​'
      },
      {
        img: 'de/Kultur/portrait_04.jpg',
        innerTitle: 'Julia',
        innerSubtitle: 'Expert Customer Sales Consultant',
        innerCopy:
          '„An meinem Job gefällt mir besonders, dass man jeden Tag ganz besondere Menschen kennenlernt. Man hört interessante Geschichten, man lacht mit den Kund:innen – manchmal weint man auch mit ihnen.“​'
      },
      {
        img: 'de/Kultur/portrait_05.jpg',
        innerTitle: 'Helena',
        innerSubtitle: 'Expert Customer Sales Consultant',
        innerCopy:
          '„Ich habe bei audibene etwas gefunden, das ich wirklich gerne vertreibe. Es ist nicht einfach der nächste Vertriebsjob, sondern ich kann hinter dem Produkt Hörgerät stehen, das einen Mehrwert für unsere Kund:innen im Alltag und im Leben schafft.“​'
      }
    ]
  },
  salesContact: {
    title: 'Du hast noch Fragen?',
    text:
      'Wir sind jederzeit für dich da!<br />E-Mail: jobs@audibene.de',
    contacts: []
  },

  //internship page

  internHero: {
    img: {
      desktop: 'de/Hero/hero-audibene-de-terrace-d.jpg',
      mobile: 'de/Hero/hero-audibene-de-terrace-m.jpg'
    },
    title: 'Become part of our team',
    subtitle: 'Shape the future of the hearing care industry with us and boost your career!',
    cta: {
      text: 'Apply now!',
      anchor: 'jobs'
    }
  },
  internWhatAwaits: {
    title: 'What awaits you at audibene',
    items: [
      {
        icon: 'de/Values/responsibility.svg',
        title: 'Responsibility',
        text: 'Bring in your ideas and drive your own projects with full ownership.'
      },
      {
        icon: 'de/TalentProgram/party_final.svg',
        title: 'Benefits',
        text: 'Benefit from offers such as lunch, sports and discounts.'
      },
      {
        icon: 'de/TalentProgram/holding_hands.svg',
        title: 'Team of Teams',
        text: 'Get wide-ranging insights into our business and learn from different teams.'
      },
      {
        icon: 'de/TalentProgram/globe.svg',
        title: 'International Projects',
        text: 'Work on international projects in a global healthtech company.'
      },
      {
        icon: 'de/TalentProgram/ear_final.svg',
        title: 'Job with purpose',
        text: "Change people's lives together with us through better hearing."
      }
    ]
  },
  aboutIntern: {
    title: 'audibene is a place to grow and learn!',
    blocks: [
      {
        text:
          'Our interns and working students are a valuable part of the team. At audibene we make sure to enable you to make an impact on the business by working on meaningful tasks and foster personal and professional growth.'
      },
      {
        text:
          "No more theory – it's time to practice and apply your skills. You’ll be right at the heart of major company projects, working with international teams of passionate and driven people."
      }
    ]
  },
  talentProgram: {
    title: 'Unleash your potential in the audibene Future Talent Program',
    blocks: [
      {
        img: {
          desktop: 'de/TalentProgram/intern_01.jpg',
          mobile: 'de/TalentProgram/intern_01.jpg'
        },
        textBlock: {
          title: 'Have real impact on the business from day one',
          text:
            'You work on meaningful tasks and projects in which you contribute independently. This makes you a fully-fledged team member.'
        }
      },
      {
        img: {
          desktop: 'de/TalentProgram/intern_02.jpg',
          mobile: 'de/TalentProgram/intern_02.jpg'
        },
        textBlock: {
          title: 'Develop yourself personally & professionally',
          text:
            'You can take part in regular training sessions and workshops. Through feedback at eye level, you define a development plan together with your team leader.'
        }
      },
      {
        img: {
          desktop: 'de/TalentProgram/intern_03.jpg',
          mobile: 'de/TalentProgram/intern_03.jpg'
        },
        textBlock: {
          title: 'Get to know a global Healthtech Company',
          text:
            'Get an overview of the business and different teams by attending Lunch & Learn sessions with experienced team members.'
        }
      },
      {
        img: {
          desktop: 'de/TalentProgram/intern_04.jpg',
          mobile: 'de/TalentProgram/intern_04.jpg'
        },
        textBlock: {
          title: 'Be part of a highly motivated international team',
          text: 'Build connections with broader teams by attending regular social events.'
        }
      }
    ]
  },
  internCarousel: {
    title: 'Get to know our Future Talents',
    slides: [
      {
        img: {
          mobile: 'de/Carousel/Michelle_m.jpg',
          desktop: 'de/Carousel/Michelle_d.jpg'
        },
        title: 'Michelle',
        subtitle: 'Working Student Talent Acquisition',
        text:
          '“I started with an internship in Talent Acquisition at audibene. I was subsequently taken on as a working student. Since then, I have been responsible for a wide variety of projects, either on my own or together with my team, and have been given a lot of personal responsibility and freedom to make decisions.”​'
      },
      {
        img: {
          mobile: 'de/Carousel/jorge_m.jpg',
          desktop: 'de/Carousel/jorge_d.jpg'
        },
        title: 'Jorge',
        subtitle: 'Intern Performance Marketing to Performance Marketing Manager',
        text:
          '“Both as an intern and now as a Performance Marketing Manager, I really enjoy the diverse range of responsibilities I get at audibene. It’s never boring! There is trust, freedom and support that I receive when making decisions. I also admire the professionalism of the people I work with. We often exchange ideas and different perspectives, there is room for creativity and learning – that will shape me as a professional.”​'
      },
      {
        img: {
          mobile: 'de/Carousel/lara_m.jpg',
          desktop: 'de/Carousel/lara_d.jpg'
        },
        title: 'Lara',
        subtitle: 'Product Management Intern to Product Manager Contact Center',
        text:
          '“I like the company culture which values open communication and helping each other. There is a feeling of mutual respect and trust, and everyone can share their opinions in a safe environment. It’s also exciting to be a part of the company’s positive mission and change people’s lives through better hearing.”'
      }
    ]
  },

  internApply: {
    title: 'How we hire',
    items: [
      {
        icon: {
          src: 'de/Apply/ico-application.svg'
        },
        text:
          '<strong>Let’s find out if we are a good match</strong><br>Apply with your resume or with your LinkedIn profile. A cover letter is not required.'
      },
      {
        icon: {
          src: 'de/Apply/ico-phone.svg'
        },
        text:
          '<strong>Recruiter Call: Get to know audibene</strong><br> During this call we will talk about your experience and motivation. We will answer any questions that you may have about audibene and the role.'
      },
      {
        icon: {
          src: 'de/Apply/ico-laptop.svg'
        },
        text:
          "<strong>Interviews: Meet your future team</strong><br>This is a good opportunity to talk about your expertise and achievements. You will also find out more about the team's strategy and discuss the expectations for the role."
      },
      {
        icon: {
          src: 'de/Apply/ico-contract.svg'
        },
        text:
          '<strong>Offer call: Making things official</strong><br>That’s the last stage of the interviewing process, where we will discuss the final details and start our journey together!'
      }
    ]
  },

  internTipps: {
    title: 'Tips for applying',
    items: [
      {
        icon: {
          color: '#A0CFEB'
        },
        text:
          '<b>Be structured and clear:</b> Don‘t overextend your CV and give us an insight into your relevant experience instead (portfolio etc.). In the interview try to illustrate your points with specific examples and highlight your skills and previous experience in your structured answer.'
      },
      {
        icon: {
          color: '#6AADE4'
        },
        text:
          '<b>Make sure to inform yourself and take some time to do additional research:</b> Read more about the history of audibene and get a better idea of the way we work. Helpful resources can be our <a href="https://karriere.audibene.de/" target="_blank">career page</a> and our <a href="https://www.instagram.com/inside.audibene/" target="_blank">@inside.audibene</a> Instagram account.'
      },
      {
        icon: {
          color: '#00549F'
        },
        text:
          '<b>Show us your motivation to join audibene:</b> We believe that everyone should hear well to live well. Our goal is to build a team of people who share this mission and our values.'
      },
      {
        icon: {
          color: '#21314D'
        },
        text:
          '<b>We would like to get to know you:</b> Be yourself and let us know how you could enrich our team. We see hiring as a two-way street- so please ask your questions to see if we’re a good fit for you.'
      }
    ]
  },

  internFAQ: {
    title: 'Want to know more?',
    items: [
      {
        title: 'What types of roles are possible for future talents?',
        text:
          'Whatever you’re studying, or if you have just finished your degree - we have all kinds of internships to suit you: working student roles, voluntary & mandatory internships. Everything from 3-6 months. Take your pick – audibene is a place to grow and learn!'
      },
      {
        title: 'Are the internships paid?',
        text:
          'Yes! We value your contribution very much and want to appropriately reward your time and effort.'
      },
      {
        title: 'Who is eligible to take part in the future talent program?',
        text:
          'Students who are enrolled at a German university and graduates up to 1 year after graduation.'
      },
      {
        title: 'Is the internship remote or in Berlin?',
        text:
          'As a Future Talent, you will benefit from hybrid working with us, which offers you the flexibility to gain valuable practical experience both in the office and from home.'
      }
    ]
  },
  internJobs: {
    title: 'Apply now!'
  },

  internContact: {
    text:
      '...or reach out to <a href="https://www.linkedin.com/in/nadja-reihofer/" target="_blank">Nadja</a> on LinkedIn!',
    contacts: [
      {
        img: 'de/TalentProgram/Nadja.jpg',
        name: 'Nadja Reihofer',
        position: 'Talent Acquisition Manager'
      }
    ]
  }
};

export default data;
